module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[51]538.f79b628.woff2";